module.exports = __webpack_public_path__ + "assets/img/a2d8c237b8e359938a941c8d7b597c27.png";